import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const courierPropList = async (params: object) => {
  return await GET({ url: Api.courierPropList, params, showError: false })
}
export const useProp = async (params: object) => {
  return await GET({ url: Api.useProp, params, showError: false })
}
export const stopProp = async (params: object) => {
  return await GET({ url: Api.stopProp, params, showError: false })
}
export const checkPropAllowUse = async (params: object) => {
  return await GET({ url: Api.checkPropAllowUse, params, showError: false })
}

export const getActivityData = async (params: object) => {
  let appInfo = ''
  try {
    appInfo = await window.bd.getHeaderParams(true)
  } catch (e) {
    if (navigator.userAgent.includes('sensors-verify')) {
      appInfo = e
    }
  }
  return await POST({
    url: Api.getActivityData,
    data: params.formData,
    isShowStatusError: false,
    headers: {
      beidou: appInfo,
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    showError: false
  })
}
